import style from "./AppSearchPage.module.scss";
import classNames from "classnames";
import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadSearchMetaData, selectRecentSearches, selectSavedSearches} from "../../../features/enhancedSearch";

const convertSavedSearches = (savedSearches) =>
  Object.keys(savedSearches ?? {}).map((key) => ({
    searchText: savedSearches[key].searchLabel,
    url: savedSearches[key].searchQuery,
  }));

const AppSearchRecentAndSaveTab = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const dispatch = useDispatch();
  const recentSearches = useSelector(selectRecentSearches);
  const savedSearches = useSelector(selectSavedSearches);

  const emptySearchMessages = [
    "You have no recent searches",
    "You have no saved searches",
  ];
  const currentResults =
    selectedTab === 0
      ? recentSearches?.combinedSearches
      : convertSavedSearches(savedSearches);

  const recentOrSavedResults = Array.isArray(currentResults)
    ? currentResults.slice(0, 6)
    : [];

  useEffect(() => {
    dispatch(loadSearchMetaData());
  }, [dispatch]);

  return (
    <div>
      <div data-testid="search-tabs" className={style.tabs}>
        <button
          className={classNames({ [style["active"]]: selectedTab === 0 })}
          onClick={() => setSelectedTab(0)}
        >
          Recent
        </button>
        <button
          className={classNames({ [style["active"]]: selectedTab === 1 })}
          onClick={() => setSelectedTab(1)}
        >
          Saved
        </button>
      </div>

      <div className={style.tabContents}>
        {recentOrSavedResults.length > 0 ? (
          recentOrSavedResults.map((item, index) => (
            <div key={index} className={style.tabLine}>
              <Link to={item.url}>
                <span dangerouslySetInnerHTML={{ __html: item.searchText }} />
              </Link>
            </div>
          ))
        ) : (
          <div className={style.emptyTabLine}>
            {emptySearchMessages[selectedTab]}
          </div>
        )}
      </div>
    </div>
  );
}

export default AppSearchRecentAndSaveTab;